__turbopack_context__.v({
  "icon": "TaskBackLink-module-scss-module___7x-3q__icon",
  "iconSm": "TaskBackLink-module-scss-module___7x-3q__iconSm",
  "label": "TaskBackLink-module-scss-module___7x-3q__label",
  "root": "TaskBackLink-module-scss-module___7x-3q__root",
});
